import { render, staticRenderFns } from "./MobView.vue?vue&type=template&id=e6c6e8b8&scoped=true"
import script from "./MobView.vue?vue&type=script&lang=js"
export * from "./MobView.vue?vue&type=script&lang=js"
import style0 from "./MobView.vue?vue&type=style&index=0&id=e6c6e8b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c6e8b8",
  null
  
)

export default component.exports